module.exports = __webpack_public_path__ + "img/reward-system.93f74d10.jpg";